// extracted by mini-css-extract-plugin
module.exports = {"aiFileButton":"aiResponseFileRender_aiFileButton__32Tpr","downloadIcon":"aiResponseFileRender_downloadIcon__1LV-q"};